import '../shared/sv-hover-intent.js';

import headerData from 'header.data';
import headerMask from 'header.mask';
import homeDecorFurniture from 'header.homedecorfurnitureflyout';
import utils from '../shared/utils';

let headerDropDowns = {};

headerDropDowns.templates = {}; 

// Config the different flyouts here
let menuConfig = headerData.getMenuConfig();

headerDropDowns.setMenuState = function _setMenuState(menuID, value) {
  if (menuConfig[menuID].isActive !== 'undefined') {
    menuConfig[menuID].isActive = value;
  }
};

headerDropDowns.openMenu = function _openMenu(menuID) {
  headerDropDowns.setMenuState(menuID, true);

  let menuActiveClass = menuConfig[menuID].name + '__link--active';
  document.querySelector('.' + menuActiveClass)?.
    classList.remove(menuActiveClass);

  let menu = document.querySelector('.ShoppingLinks__link[data-id="' + menuConfig[menuID].name + '"]');
  menu.classList.add('ShoppingLinks__link--force-open');
  menu.classList.add('js__flyout--open');

  if (menuID === 'homeDecorFurniture') {
    // Show Home Decor & Furniture flyout
    document.querySelector('.homeDecorFurnitureFlyout__link--active')?.
      classList.remove('homeDecorFurnitureFlyout__link--active');
    document.querySelector('.homeDecorFurnitureFlyout__subnav-wrapper')?.
      classList.add(menuConfig[menuID].menuClass + '--open');

    window.setTimeout(function _openFlyoutWithDelay() {
      // Only render the flyout it its data has been retrieved
      if (homeDecorFurniture.getHomeDecorFurnitureData()) {
        document.querySelector('.homeDecorFurnitureFlyout__link#home-decor')?.
          classList.add('homeDecorFurnitureFlyout__link--active');
        // Automatically render Home Decor flyout
        document.querySelector('.homeDecorFurnitureFlyout__menu')?.
          classList.add('homeDecorFurnitureFlyout__menu--open');
        homeDecorFurniture.getPrivateMethods().renderMenu('Home Decor');
      }
    }, 500);
  } else {
    document.querySelector('.' + menuConfig[menuID].menuClass)?.
      classList.add(menuConfig[menuID].menuClass + '--open');

    // Close the Home Decor & Furniture flyout if it opened after user switched to a different menu
    document.querySelector('.homeDecorFurnitureSubnav__subnav-wrapper')?.
      classList.remove('homeDecorFurnitureSubnav--open');
    document.querySelector('.homeDecorFurnitureFlyout__menu-wrapper')?.
      classList.remove('homeDecorFurnitureFlyout--open');
  }
};

headerDropDowns.closeMenu = function _closeMenu(menuID) {
  headerDropDowns.setMenuState(menuID, false);

  document.querySelector('.ShoppingLinks__link[data-id="' + menuID + '"]')?.
    classList.remove('ShoppingLinks__link--force-open');
  // Don't see an event listener for 'flyout'
  // document.querySelector('.ShoppingLinks__link[data-id="' + menuID + '"]')?.  
  //   removeEventListener('.flyout');

  const mainFlyOutClasses = document.querySelector('.MainFlyout')?.classList;
  mainFlyOutClasses?.remove('MainFlyout--open');
  mainFlyOutClasses?.remove('MainFlyout--panels-3');
  mainFlyOutClasses?.remove('MainFlyout--panels-4');
  const mainFlyoutLinks = document.querySelectorAll('.MainFlyout__link');
  mainFlyoutLinks.forEach(element => {
    element?.classList?.remove('MainFlyout__link--active');
  })

  document.querySelector('.' + menuConfig[menuID].menuClass)?.
    classList.remove(menuConfig[menuID].menuClass + '--open');

  if (menuID === 'homeDecorFurniture') {
    document.querySelector('.homeDecorFurnitureSubnav__subnav-wrapper')?.
      classList.remove('homeDecorFurnitureSubnav--open');
    document.querySelector('.homeDecorFurnitureFlyout__link--active')?.
      classList.remove('homeDecorFurnitureFlyout__link--active');

    homeDecorFurniture.highlightSubnavAisle(homeDecorFurniture.getBreadcrumbAisleElements());
  }

  // Close the Home Decor & Furniture menu if it opened after user closed the Home Decor & Furniture menu 
  window.setTimeout(function _closeHomeDecorFurnitureFlyoutIfOpen() {
    document.querySelector('.homeDecorFurnitureFlyout__menu-wrapper')?.
      classList.remove('homeDecorFurnitureFlyout--open');
  }, 500);

  headerMask.destroy();
};

headerDropDowns.closeAllMenus = function _closeAllMenus() {
  Object.keys(menuConfig).forEach(function _closeEachMenu(key) {
    headerDropDowns.closeMenu(key);
  });
  headerDropDowns.removeHoverIntent('.Header3');
};

headerDropDowns.toggleMenu = function _toggleMenu(event) {
  const isEventTypeHoverIntent = event?.target ? false : true;
  let menuID;

  if(isEventTypeHoverIntent) {
    menuID = event.getAttribute('data-id') //target is received in hoverintent and not the event    
  } else {
    menuID = event.target.getAttribute('data-id')
  }

  if (!headerDropDowns.isSurfacePro() && menuID) {
    document.dispatchEvent(new Event('closeHeaderTooltips'));
    if ((headerData.isDropDown() || menuID === 'departmentsFlyout') && !isEventTypeHoverIntent) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (menuConfig[menuID].isActive && !isEventTypeHoverIntent) {
      headerDropDowns.closeMenu(menuID);
    } else {
      headerDropDowns.closeAllMenus();
      headerDropDowns.setMenuState(menuID, true);
      if (headerData.isDropDown() || menuID === 'departmentsFlyout') {
        headerMask.show();
        headerDropDowns.openMenu(menuID);
      }
    }
  } else {
    headerDropDowns.closeAllMenus();
  }
  headerDropDowns.closeTypeAhead();
};

headerDropDowns.isSurfacePro = function isSurfacePro() {
  if (!(navigator.userAgent).match(/Edge/g)) {
    return (navigator.userAgent.match(/Edge/g) !== null);
  }
  return false;
};

headerDropDowns.removeHoverIntent = function _removeHoverIntent(element) {
  document.querySelector(element)?.removeEventListener('.hoverIntent', headerDropDowns.triggerHoverintent);
  return element;
};

headerDropDowns.triggerHoverintent = function _triggerHoverIntent(targetItem) {
  document.dispatchEvent(new CustomEvent('hoverintent', {
    detail: {
      targetItem
    }
  }));
};

headerDropDowns.breakpointChanged = function _breakpointChanged(event, eventInfo) {
  const newInList = ['lg', 'md', 'sm'].indexOf(event?.detail?.new || eventInfo?.new);
  const oldInList = ['default', 'xs'].indexOf(event?.detail?.old || eventInfo?.old);

  if ((newInList > -1) && (oldInList > -1)) {
    // If we're in a larger break point
    document.dispatchEvent(new CustomEvent('showSimpleFlyout', {detail:{open:false}}));
  } else if ((newInList === -1) && (oldInList === -1)) {
    // If we're in a smaller break point
    headerDropDowns.closeAllMenus();
  }
};

headerDropDowns.closeOnSearchOpen = function _closeOnSearchOpen(event, isOpen) {
  if (event?.detail?.open || isOpen) {
    headerDropDowns.closeAllMenus();
  }
};

headerDropDowns.closeTypeAhead = function closeTypeAhead() {
  const headerSearch = document.getElementById('headerSearch');
  const isSearchBarFocused = (headerSearch === document.activeElement) ? true : false;
  if (isSearchBarFocused) {
    headerSearch.blur();
    document.getElementById('typeAheadFlyOut')?.
      classList.remove('typeahead__show');
  }
};

headerDropDowns.initialize = function initialize() {
  utils.delegateListeners(['touchend'], '.Header3 .ShoppingLinks__link', headerDropDowns.toggleMenu);
  let shoppingLinksHoverIntent = new SV.HoverIntent(document.querySelectorAll('.Header3 .ShoppingLinks__link'), {
    onEnter: (targetItem) => {
      headerDropDowns.toggleMenu(targetItem);
    },
    onExit: () => { }
  })

  utils.delegateListeners(['click', 'touchend'], '.Mask', headerDropDowns.closeAllMenus);

  let maskHoverIntent = new SV.HoverIntent(document.querySelectorAll('.Mask'), {
    onEnter: (targetItem) => {
      headerDropDowns.closeAllMenus(targetItem);
    },
    onExit: () => { }
  })

  utils.addListenersToAll(['click', 'touchend'], '.Header3', headerDropDowns.closeAllMenus);
  
  document.addEventListener('closeAllMenus', headerDropDowns.closeAllMenus);
  document.addEventListener('breakpointChanged', headerDropDowns.breakpointChanged);
  document.addEventListener('searchState', headerDropDowns.closeOnSearchOpen);
  document.addEventListener('maskhoverintent', headerDropDowns.closeAllMenus);
  
  let headerShoppinglinksHoverIntent = new SV.HoverIntent(document.querySelectorAll('.Header3 .ShoppingLinks__link'), {
    onEnter: function (targetItem) {
      headerDropDowns.triggerHoverintent(targetItem);
    },
    onExit: () => { }
  });

  let logoHoverIntent = new SV.HoverIntent(document.querySelectorAll('.Header3 .HeaderLogo'), {
    onEnter: function (targetItem) {
      headerDropDowns.triggerHoverintent(targetItem);
    },
    onExit: () => { }
  });
};

/*
 * Public Methods
 */

headerDropDowns.templates.diyFlyout =
  '<section class="grid diyFlyout__level1">' +
  '    <div class="col__12-12 diyFlyout__wrapper">' +
  '        <div class="grid">' +
  '            {{#links}} ' +
  '                <div class="col__2-12">' +
  '                    <div class="content">' +
  /* based on CTA, image is rendered as clickable or only image */
  '                        <div class="content_image">' +
  '                            {{#link}} ' +
  '                                <a href="{{link}}" alt="{{{title}}}">' +
  '                                    <img src="{{image}}" class="diyFlyout__image stretchy">' +
  '                                </a>' +
  '                            {{/link}} ' +
  '                            {{^link}} ' +
  '                                <img src="{{image}}" class="diyFlyout__image stretchy">' +
  '                            {{/link}} ' +
  '                        </div>' +
  /* based on CTA, text is rendered as clickable or only text */
  '                        {{#link}} ' +
  '                            <a href="{{link}}" class="cta--inline diyFlyout__level2link">' +
  '                                <span class="cta__text">' +
  '                                    {{{title}}} ' +
  '                                </span>' +
  '                                <span class="cta__arrow"></span>' +
  '                            </a>' +
  '                        {{/link}} ' +
  '                        {{^link}} ' +
  '                            <h4 class="cta__text diyFlyout__level2text">' +
  '                                {{{title}}} ' +
  '                            </h4>' +
  '                        {{/link}} ' +
  '                        <ul class="list list--type-plain diyFlyout__list">' +
  '                            {{#sublinks}} ' +
  '                                <li class="list__item">' +
  '                                    <a href="{{link}}" class="list__link diyFlyout__level3link">{{{title}}}</a>' +
  '                                </li>' +
  '                            {{/sublinks}} ' +
  '                        </ul>' +
  '                    </div>' +
  '                </div>' +
  '            {{/links}} ' +

  '            {{#picture}} ' +
  '                <div class="col__2-12">' +
  '                    <img src="{{imageURL}}" class="diyFlyout__image stretchy">' +
  '                </div>' +
  '            {{/picture}} ' +

  '        </div>' +
  '    </div>' +
  '</section>;';

headerDropDowns.templates.hsFlyout =
  '<section class="grid hsFlyout__level1">' +
  '    <div class="col__12-12 hsFlyout__wrapper">' +
  '        <div class="grid">' +
  '            {{#links}} ' +
  '                <div class="col__3-12">' +
  '                    <div class="content">' +
  /* based on CTA, image is rendered as clickable or only image */
  '                        <div class="content_image">' +
  '                            {{#link}} ' +
  '                                <a href="{{link}}" alt="{{{title}}}">' +
  '                                    <img src="{{image}}" class="hsFlyout__image stretchy">' +
  '                                </a>' +
  '                            {{/link}} ' +
  '                            {{^link}} ' +
  '                                <img src="{{image}}" class="hsFlyout__image stretchy">' +
  '                            {{/link}} ' +
  '                        </div>' +
  /* based on CTA, text is rendered as clickable or only text */
  '                        {{#link}} ' +
  '                            <a href="{{link}}" class="cta--inline hsFlyout__level2link">' +
  '                                <span class="cta__text">' +
  '                                    {{{title}}} ' +
  '                                </span>' +
  '                                <span class="cta__arrow"></span>' +
  '                            </a>' +
  '                        {{/link}} ' +
  '                        {{^link}} ' +
  '                            <h4 class="cta__text hsFlyout__level2text">' +
  '                                {{{title}}} ' +
  '                            </h4>' +
  '                        {{/link}} ' +
  '                        <ul class="list list--type-plain hsFlyout__list">' +
  '                            {{#sublinks}} ' +
  '                                <li class="list__item">' +
  '                                    <a href="{{link}}" class="list__link hsFlyout__level3link">{{{title}}}</a>' +
  '                                </li>' +
  '                            {{/sublinks}} ' +
  '                        </ul>' +
  '                    </div>' +
  '                </div>' +
  '            {{/links}} ' +
  '        </div>' +
  '    </div>' +
  '</section>;';

headerDropDowns.init = function init() {
  headerDropDowns.initialize();
  return this;
};

headerDropDowns.getPrivateMethods = () => headerDropDowns;

export default headerDropDowns;
